module.exports = __webpack_public_path__ + "static/media/logo-beta.773e9ef7.svg";